import { defineComponent as _defineComponent } from 'vue';
import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "grey lighten-5 px-4 py-4" };
const _hoisted_2 = { class: "require-field-wrapper pb-4" };
import { computed, ref, watch, } from 'vue';
import { numberToFormatted, formattedToNumber, assertValidForm, currency, } from '@/utils';
import { NUMBER_REG_EXP } from '@/utils/regularExpression';
import { BusinessError } from '@/error';
import { validationLimitingValue } from '@/constants';
import { i18n } from '@/locales';
import vuexStore from '@/vuex-store';
import DialogHeader from '@/components/Dialog/DialogHeader.vue';
import DialogFooter from '@/components/Dialog/DialogFooter.vue';
import { snackbarActionType } from '@/vuex-store/snackbar/actions';
const lc = 'views.order_detail.order_detail_delivery_info.';
export default /*@__PURE__*/ _defineComponent({
    __name: 'AddWorkerSupportAmountDialog',
    setup(__props) {
        // 라이더 지원금 변경 모달
        const workerSupportMaximumAmount = numberToFormatted(validationLimitingValue.WORKER_SUPPORT_MAXIMUM_AMOUNT);
        const form = ref(null);
        const dialog = ref(false);
        const valid = ref(false);
        const errorMessage = ref('');
        const newWorkerSupportAmount = ref('0');
        const formattedNewWorkerSupportAmount = ref('0');
        const order = computed(() => vuexStore.state.order.order);
        const orderId = computed(() => order.value.orderId);
        const rules = {
            // eslint-disable-next-line no-return-assign
            required: (v) => !!v || (errorMessage.value = i18n.t(`${lc}worker_support_amount_label`)),
            // eslint-disable-next-line no-return-assign
            maximum: () => newWorkerSupportAmount.value <= formattedToNumber(workerSupportMaximumAmount)
                || (errorMessage.value = i18n.t(`${lc}add_worker_support_maximum_error`, {
                    worker_support_maximum_amount: workerSupportMaximumAmount,
                })),
            // eslint-disable-next-line no-return-assign
            notChange: () => newWorkerSupportAmount.value !== order.value.workerSupportAmount
                || (errorMessage.value = i18n.t(`${lc}not_changed_worker_support_amount`, {
                    adjust_delivery_maximum_amount: workerSupportMaximumAmount,
                })),
        };
        const _resetValidation = () => {
            form.value?.resetValidation();
        };
        const _initializeWorkerSupportAmount = () => {
            _resetValidation();
            dialog.value = false;
            formattedNewWorkerSupportAmount.value = '0';
        };
        const _validateForm = () => form.value?.validate();
        const _requestAddWorkerSupportAmount = async () => {
            try {
                _validateForm();
                assertValidForm(valid.value, errorMessage.value);
                if (!valid.value) {
                    return;
                }
                const payload = {
                    orderId: orderId.value,
                    workerSupportAmount: newWorkerSupportAmount.value,
                };
                await vuexStore.dispatch('order/addWorkerSupportAmount', payload);
                vuexStore.dispatch('snackbar/showSuccess', {
                    message: i18n.t(`${lc}success_change_worker_support_amount`),
                });
                _initializeWorkerSupportAmount();
            }
            catch (error) {
                let message = i18n.t('common.failure');
                if (error instanceof BusinessError) {
                    if (error.reason) {
                        vuexStore.dispatch(snackbarActionType.showError, {
                            message: error.message,
                            messageProps: error.reason,
                        });
                        return;
                    }
                    message = error.message;
                }
                vuexStore.dispatch(snackbarActionType.showError, message);
            }
        };
        /**
         * 취소 핸들러
         */
        const handleClickCancelWorkerSupportAmount = () => {
            _initializeWorkerSupportAmount();
        };
        /**
         * 확인 핸들러
         */
        const handleClickConfirmWorkerSupportAmount = () => {
            _requestAddWorkerSupportAmount();
        };
        /**
          * 라이더 지원금 input keyup event handler
          * @param {string} $event.key
          */
        // TODO 현재 숫자가 아닐 시  잘못 입력된 글자 보여주고 지워지도록 하기 위해 keyup과 watch가 사용됨, 불필요한 기능으로 판단되고 다른 페이지와의 통일성을 위해 추후 PM,PD와 협의 필요
        // 논의 슬랙링크: https://barogo.slack.com/archives/C04UP4VFCKA/p1687325121736529
        const handleWorkerSupportAmountInputKeyupEvent = (eventKey) => {
            const numberRegExp = NUMBER_REG_EXP;
            const isNumber = numberRegExp.test(eventKey);
            if (!isNumber && eventKey === 'Backspace') {
                formattedNewWorkerSupportAmount.value = formattedNewWorkerSupportAmount.value.slice(0, -1);
            }
            formattedNewWorkerSupportAmount.value = numberToFormatted(Number(newWorkerSupportAmount.value));
        };
        watch(formattedNewWorkerSupportAmount, (value) => {
            newWorkerSupportAmount.value = formattedToNumber(value);
        });
        return (_ctx, _cache) => {
            const _component_v_card_title = _resolveComponent("v-card-title");
            const _component_v_divider = _resolveComponent("v-divider");
            const _component_v_card = _resolveComponent("v-card");
            const _component_v_text_field = _resolveComponent("v-text-field");
            const _component_v_form = _resolveComponent("v-form");
            const _component_v_dialog = _resolveComponent("v-dialog");
            return (_openBlock(), _createBlock(_component_v_dialog, {
                modelValue: dialog.value,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((dialog).value = $event)),
                "content-class": "responsive-dialog",
                "onClick:outside": handleClickCancelWorkerSupportAmount,
                onKeydown: _withKeys(handleClickCancelWorkerSupportAmount, ["esc"])
            }, {
                activator: _withCtx(({ props }) => [
                    _renderSlot(_ctx.$slots, "activator", _normalizeProps(_guardReactiveProps(props)))
                ]),
                default: _withCtx(() => [
                    _createVNode(_component_v_card, null, {
                        default: _withCtx(() => [
                            _createVNode(DialogHeader, {
                                title: _ctx.$t(`${lc}change_worker_support_amount`),
                                "on-cancel": handleClickCancelWorkerSupportAmount
                            }, null, 8 /* PROPS */, ["title"]),
                            _createVNode(_component_v_card, {
                                flat: "",
                                tile: ""
                            }, {
                                default: _withCtx(() => [
                                    _createCommentVNode(" 변경 전 "),
                                    _createVNode(_component_v_card_title, { class: "text-subtitle-2 brg-color-grey-600 pb-0" }, {
                                        default: _withCtx(() => [
                                            _createElementVNode("span", null, _toDisplayString(_ctx.$t('common.before_change')), 1 /* TEXT */)
                                        ]),
                                        _: 1 /* STABLE */
                                    }),
                                    _createVNode(_component_v_card_title, { class: "text-body-1 pt-2" }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_unref(currency)(order.value?.workerSupportAmount)), 1 /* TEXT */)
                                        ]),
                                        _: 1 /* STABLE */
                                    }),
                                    _createVNode(_component_v_divider)
                                ]),
                                _: 1 /* STABLE */
                            }),
                            _createCommentVNode(" 변경 후 "),
                            _createElementVNode("div", _hoisted_1, [
                                _createElementVNode("div", _hoisted_2, [
                                    _createVNode(_component_v_card_title, { class: "text-subtitle-2 brg-color-grey-600 pb-0" }, {
                                        default: _withCtx(() => [
                                            _createElementVNode("span", null, _toDisplayString(_ctx.$t('common.after_change')), 1 /* TEXT */),
                                            _cache[4] || (_cache[4] = _createElementVNode("span", { class: "text-red" }, "*", -1 /* CACHED */))
                                        ]),
                                        _: 1 /* STABLE */,
                                        __: [4]
                                    }),
                                    _createVNode(_component_v_card_title, { class: "body2-text brg-color-grey-600 py-2" }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t(`${lc}notice_worker_support_amount_maximum`, {
                                                worker_support_maximum_amount: _unref(workerSupportMaximumAmount)
                                            })), 1 /* TEXT */)
                                        ]),
                                        _: 1 /* STABLE */
                                    }),
                                    _createVNode(_component_v_form, {
                                        ref_key: "form",
                                        ref: form,
                                        modelValue: valid.value,
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((valid).value = $event)),
                                        onSubmit: _withModifiers(handleClickConfirmWorkerSupportAmount, ["prevent"])
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_text_field, {
                                                modelValue: formattedNewWorkerSupportAmount.value,
                                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((formattedNewWorkerSupportAmount).value = $event)),
                                                density: "compact",
                                                variant: "outlined",
                                                dense: "",
                                                "hide-details": "auto",
                                                inputmode: "numeric",
                                                "validate-on": "blur",
                                                placeholder: _ctx.$t(`common.amount_required`),
                                                suffix: _ctx.$t('common.currency'),
                                                rules: [rules.required, rules.maximum, rules.notChange],
                                                class: "px-4",
                                                onKeyup: _cache[1] || (_cache[1] = ($event) => (handleWorkerSupportAmountInputKeyupEvent($event.key)))
                                            }, null, 8 /* PROPS */, ["modelValue", "placeholder", "suffix", "rules"])
                                        ]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["modelValue"])
                                ])
                            ]),
                            _createVNode(_component_v_divider),
                            _createVNode(DialogFooter, {
                                cancel: true,
                                ok: true,
                                "on-cancel": handleClickCancelWorkerSupportAmount,
                                "on-ok": handleClickConfirmWorkerSupportAmount
                            })
                        ]),
                        _: 1 /* STABLE */
                    })
                ]),
                _: 3 /* FORWARDED */
            }, 8 /* PROPS */, ["modelValue"]));
        };
    }
});
